export default __webpack_public_path__ + "static/media/three-dots-vertical2.426417ae.svg";